export enum GTMEvents {
  BUILDER_CLOSED = 'BUILDER_CLOSED',
  BUILDER_OPENED = 'BUILDER_OPENED',
  BUILDER_SHELL_WAIT = 'BUILDER_SHELL_WAIT',
  BUILDER_STEP_CLOSED = 'BUILDER_STEP_CLOSED',
  BUILDER_STEP_OPENED = 'BUILDER_STEP_OPENED',
}

export const trackEvent = options => {
  options.custom = {
    // Name of the custom GTM env
    gtmEnv: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ENV_NAME,
    // Api env
    apiEnv: process.env.REACT_APP_GOOGLE_TAG_MANAGER_API_ENV,
  };

  return globalThis?.dataLayer?.push(options);
};
